<xen-modal
  size="lg"
  [modal_title]="modalTitle"
  subtitle="{{
    editUser
      ? 'Update the information for this user within the organization.'
      : 'Extend an invitation to a new user to join your organization.'
  }}"
>
  <div xenModalBody>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-12">
        <div class="xen-stepper mb-4">
          @for (step of steps; track step.id) {
            <xen-step
              [label]="step.label"
              [current]="step.current"
              [edit]="step.edit"
              [disabled]="false"
              [status]="step.status"
              [ngClass]="step.level"
              [level]="step.level"
              (click)="editStep(step)"
            ></xen-step>
          }
        </div>
        <div [class.d-none]="currentStep !== 3">
          <xen-meta-help-slider [helpData]="metaHelp" [alignTop]="true"></xen-meta-help-slider>
        </div>
      </div>

      <div class="col-lg-9 col-md-9 col-12">
        @for (titleModal of titleModals; track titleModal.id) {
          <div [class.d-none]="!titleModal.active">
            <div class="mb-3">
              <xen-title-section
                title="{{ titleModal.title }}"
                subtitle="{{ titleModal.subtitle }}"
              ></xen-title-section>
            </div>
          </div>
        }

        <div [class.d-none]="currentStep !== 1">
          <div class="row" [formGroup]="emailForm">
            <div class="col-12 mb-3">
              <xen-input
                label="Email"
                [type]="'email'"
                [formControlName]="'email'"
                [size]="'medium'"
                [placeholder]="'e.g. john.doe@johntravels.com'"
                [required]="true"
                [validation]="true"
                [validation_status]="
                  emailForm.invalid && emailForm.get('email').dirty
                    ? 'is-invalid'
                    : emailForm.valid && emailForm.get('email').dirty
                      ? 'is-valid'
                      : ''
                "
                [feedback]="emailForm.invalid ? emailForm.get('email').errors['errorMsg'] : ''"
              ></xen-input>
            </div>
            <xen-btn
              (clicked)="onSubmitEmail()"
              type="primary"
              size="medium"
              label="Continue"
              [icon]="true"
              icon_placement="right"
              [disabled]="emailForm.invalid"
              icon_snippet="fa-regular fa-arrow-right"
              skin="blue"
            ></xen-btn>
          </div>
        </div>

        <div [class.d-none]="currentStep !== 2">
          @if (!isLoading) {
            <div class="row" [formGroup]="userInfoForm">
              @if (!isUserExisting && !editUser) {
                <xen-alert
                  [type]="alertTypeInfo"
                  content="<span>The created user will receive an email to activate their account and password.</span>"
                  [icon]="true"
                  icon_snippet="fa-solid fa-circle-info"
                  [dismiss]="false"
                ></xen-alert>
              }
              @if (isUserExisting && !editUser) {
                <xen-alert
                  [type]="alertTypeWarning"
                  content="<span>It looks like this user already exists in Travelgate. You can add them to your organization by specifying their job title.</span>"
                  [icon]="true"
                  icon_snippet="fa-solid fa-triangle-exclamation"
                  [dismiss]="false"
                ></xen-alert>
              }

              <div class="col-12 mb-3">
                <xen-input
                  label="First Name"
                  [disabled]="editUser"
                  formControlName="firstName"
                  size="medium"
                  placeholder="e.g. John"
                  [required]="true"
                  [validation]="!isUserExisting"
                  [validation_status]="getValidationStatus('firstName')"
                  [feedback]="
                    userInfoForm.invalid && userInfoForm.get('firstName').dirty
                      ? $safeNavigationMigration(userInfoForm.get('firstName').errors?.errorMsg)
                      : ''
                  "
                ></xen-input>
              </div>

              <div class="col-12 mb-3">
                <xen-input
                  label="Last Name"
                  [disabled]="editUser"
                  formControlName="lastName"
                  size="medium"
                  placeholder="e.g. Doe"
                  [required]="true"
                  [validation]="!isUserExisting"
                  [validation_status]="getValidationStatus('lastName')"
                  [feedback]="
                    userInfoForm.invalid && userInfoForm.get('lastName').dirty
                      ? $safeNavigationMigration(userInfoForm.get('lastName').errors?.errorMsg)
                      : ''
                  "
                ></xen-input>
              </div>

              <div class="col-12 mb-3">
                <div class="bottom_separator">
                  <xen-input
                    label="Job Title"
                    formControlName="jobTitle"
                    size="medium"
                    placeholder="e.g. Manager"
                    [required]="true"
                    [validation]="true"
                    [validation_status]="getValidationStatus('jobTitle')"
                  ></xen-input>
                </div>
              </div>

              <div class="col-12 mb-3">
                <strong>Assign this contact to receive notifications from Travelgate.</strong>
                @if (!canEditContacts) {
                  <span class="tooltip_styles" tooltipClass="xen-tooltip" ngbTooltip="{{ editContactsTooltipText }}">
                    <i class="fas fa-info-square ms-1"></i>
                  </span>
                }
                <div class="d-flex justify-content-start align-items-start gap-4">
                  @if (contactsLoaded) {
                    @if (isBuyer) {
                      <div [formGroup]="buyerContactsForm" class="mt-3">
                        @if (isSeller && isBuyer) {
                          <label class="form-label me-2">Organization type</label>
                          <xen-badge type="label" label="Buyer" status="buyer" theme="light"></xen-badge>
                        }

                        @for (contact of mainContacts; track contact.controlName) {
                          <div
                            class="mb-2 main-contacts-indent"
                            [class.d-none]="
                              contact.controlName === ContactType.BILLING && isBuyer && !showBuyerBillingInput
                            "
                          >
                            <xen-checkbox
                              [disabled]="!canEditContacts"
                              [label]="contact.label"
                              [formControlName]="contact.controlName"
                              [tooltip]="true"
                              [tooltip_text]="contact.tooltip"
                              [id]="'buyer_' + $index"
                            ></xen-checkbox>
                          </div>
                        }
                      </div>
                    }
                    @if (isSeller) {
                      <div [formGroup]="sellerContactsForm" class="mt-3">
                        @if (isSeller && isBuyer) {
                          <label class="form-label me-2">Organization type</label>
                          <xen-badge type="label" label="Seller" status="seller" theme="light"></xen-badge>
                        }
                        @for (contact of mainContacts; track contact.controlName) {
                          <div
                            class="mb-2 main-contacts-indent"
                            [class.d-none]="
                              contact.controlName === ContactType.BILLING && isSeller && !showSellerBillingInput
                            "
                          >
                            <xen-checkbox
                              [label]="contact.label"
                              [formControlName]="contact.controlName"
                              [tooltip]="true"
                              [tooltip_text]="contact.tooltip"
                              [id]="'seller_' + $index"
                              [disabled]="
                                (contact.controlName === ContactType.BILLING && hasSameBillingAccount) ||
                                !canEditContacts
                              "
                            ></xen-checkbox>

                            @if (contact.controlName === ContactType.BILLING && hasSameBillingAccount) {
                              <p class="text-secondary mt-1 mb-0 small">
                                The Billing contact for Seller is the same as for Buyer.
                              </p>
                            }
                          </div>
                        }
                      </div>
                    }
                  } @else {
                    <div class="d-flex gap-5 mt-3">
                      @if (isBuyer) {
                        <div>
                          <p-skeleton width="5rem" height="1rem" class="mb-3"></p-skeleton>
                          @for (item of [1, 2, 3, 4]; track $index) {
                            <div class="d-flex align-items-center gap-2 mb-2">
                              <p-skeleton width="1.25rem" height="1.25rem" borderRadius="4px"></p-skeleton>
                              <p-skeleton [width]="$index % 2 === 0 ? '9rem' : '7rem'" height="1rem"></p-skeleton>
                            </div>
                          }
                        </div>
                      }
                      @if (isSeller) {
                        <div>
                          <p-skeleton width="5rem" height="1rem" class="mb-3"></p-skeleton>
                          @for (item of [1, 2, 3, 4]; track $index) {
                            <div class="d-flex align-items-center gap-2 mb-2">
                              <p-skeleton width="1.25rem" height="1.25rem" borderRadius="4px"></p-skeleton>
                              <p-skeleton [width]="$index % 2 === 0 ? '9rem' : '7rem'" height="1rem"></p-skeleton>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>

              <div class="col-12">
                <div class="d-flex align-items-center">
                  <xen-btn
                    [disabled]="editUser"
                    type="flat"
                    size="medium"
                    label="Previous step"
                    [icon]="true"
                    icon_placement="left"
                    icon_snippet="fa-regular fa-arrow-left"
                    skin="blue"
                    class="me-2"
                    (clicked)="goToPreviousStep(1)"
                  ></xen-btn>
                  <xen-btn
                    (clicked)="onSubmitUserInfo()"
                    type="primary"
                    size="medium"
                    label="Continue"
                    [icon]="true"
                    icon_placement="right"
                    [disabled]="userInfoForm.invalid"
                    icon_snippet="fa-regular fa-arrow-right"
                    skin="blue"
                  ></xen-btn>
                </div>
              </div>
            </div>
          } @else {
            <ng-container [ngTemplateOutlet]="userInfoSkeleton"></ng-container>
          }
        </div>

        <div [class.d-none]="currentStep !== 3">
          <div class="row">
            <xen-alert
              [type]="alertTypeWarning"
              [content]="
                canEditRoles
                  ? '<span>Please configure the permissions for this user carefully. Each selection determines the specific actions and sensitive data they will be able to access within the organization</span>'
                  : editRolesTooltipText
              "
              [icon]="true"
              icon_snippet="fa-solid fa-triangle-exclamation"
              [dismiss]="false"
            ></xen-alert>

            <tgx-user-permissions
              [user]="user"
              [orgCode]="orgCode"
              [canEditRoles]="canEditRoles"
              (permissionschanged)="updatePermissions($event)"
              (allUserPermissions)="initialUserPermissions($event)"
              (previousStep)="goToPreviousStep($event)"
              (invalidForm)="handleInvalidForm($event)"
              (billingSelectionInvalid)="handleBillingSelectionInvalid($event)"
            ></tgx-user-permissions>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div xenModalFooter>
    <div class="d-flex align-items-center">
      <xen-btn
        type="flat"
        label="Close"
        skin="gray"
        class="ms-2"
        (clicked)="closeModal()"
        style="margin-right: 10px"
      ></xen-btn>

      <xen-btn
        [hidden]="currentStep !== 3"
        [disabled]="isSendLoading || finishDisabled"
        [loading]="isSendLoading"
        type="primary"
        size="medium"
        [label]="editUser ? 'Edit user' : 'Invite user'"
        skin="blue"
        (click)="onSubmit(editUser)"
      ></xen-btn>
    </div>
  </div>
</xen-modal>

<ng-template #userInfoSkeleton>
  <div class="row">
    <p-skeleton class="mb-2"></p-skeleton>
    <p-skeleton class="mb-4"></p-skeleton>
    @for (section of [1, 2, 3, 4]; track section) {
      <div class="col-lg-12 col-md-12 col-12 mb-4">
        <p-skeleton width="10rem" class="mb-2"></p-skeleton>
        <p-skeleton class="mb-2"></p-skeleton>
      </div>
    }
  </div>
</ng-template>
